window._cartRefresh = async function (){
  const cartItems = document.querySelector('cart-items');
  const cartDrawer = document.querySelector('cart-drawer');
  const sections = [
    {
      id: 'cart-progress-bar',
      section: 'cart-progress-bar',
      selector: '.js-contents',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    },
    {
      id: 'cart-live-region-text',
      section: 'cart-live-region-text',
      selector: '.shopify-section'
    },
    {
      id: 'main-cart-footer',
      section: 'main-cart-footer',
      selector: '.js-contents',
    },
    {
      id: 'main-cart-items',
      section: 'main-cart-items',
      selector: '.js-contents',
    },
  ];

  const sectionNamesArray = sections.map(section => section.section);
  const sectionNamesString = sectionNamesArray.join(',');

  fetch(`/?sections=${sectionNamesString}`)
  .then(response => {
    return response.text()
  })
  .then(state => {
    const parsedState = JSON.parse(state)


    sections.forEach(section => {
      const sectionToUpdate = document.getElementById(section.id)
      const elementToReplace = sectionToUpdate.querySelector(section.selector) || sectionToUpdate;
      elementToReplace.innerHTML = cartItems.getSectionInnerHTML(parsedState[section.section], section.selector);
    })
    const hidden = document.querySelectorAll('.cart__reload.is-empty')
    if (hidden.length) {
      hidden.forEach(element => {
       element.classList.remove('is-empty')
      })
    }
    const event = new CustomEvent('updatecart')
    window.dispatchEvent(event)
    if(cartDrawer){
      cartDrawer.openMenuDrawer()
    }
  })
  .catch(e => {
    console.log(e)
  })
}